"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerEditPageActions = exports.CustomerEditPage = exports.CustomerDetailPageActions = exports.CustomerDetailPage = exports.CustomerListPage = void 0;
var customerDetailPage_1 = require("./customerDetailPage");
exports.CustomerDetailPage = customerDetailPage_1.default;
var customerDetailPageActions_1 = require("./customerDetailPageActions");
exports.CustomerDetailPageActions = customerDetailPageActions_1.default;
var customerEditPage_1 = require("./customerEditPage");
exports.CustomerEditPage = customerEditPage_1.default;
var customerEditPageActions_1 = require("./customerEditPageActions");
exports.CustomerEditPageActions = customerEditPageActions_1.default;
var customerListPage_1 = require("./customerListPage");
exports.CustomerListPage = customerListPage_1.default;
